import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/contract/$id/_layout/_placeholders/approval-info",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ComingSoonCover />;
}
